<!-- ══ TABS ══ -->
<div class="mb-6 flex flex-wrap gap-0 border-b border-gray-200 dark:border-gray-800">
  @for (tab of tabs; track tab.key) {
    <button (click)="setTab(tab.key)"
            class="px-4 py-2.5 -mb-px text-sm font-medium border-b-2 transition-colors"
            [class.border-teal-600]="activeTab === tab.key"
            [class.text-teal-700]="activeTab === tab.key"
            [class.dark:text-teal-300]="activeTab === tab.key"
            [class.border-transparent]="activeTab !== tab.key"
            [class.text-gray-500]="activeTab !== tab.key"
            [class.hover:text-gray-700]="activeTab !== tab.key"
            [class.dark:hover:text-gray-200]="activeTab !== tab.key">
      {{ tab.label }}
    </button>
  }
</div>

<!-- ══════════════════════════════════════════
     TAB: DETALLE
══════════════════════════════════════════ -->
@if (activeTab === 'overview') {
  <div class="grid grid-cols-1 gap-5 lg:grid-cols-5">

    <!-- Columna principal -->
    <div class="lg:col-span-3">
      <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
        <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60">
          <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            Información del correo
          </h2>
        </div>
        <dl class="divide-y divide-gray-100 dark:divide-gray-800">
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Estado del correo</dt>
            <dd>
              <span class="inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold" [class]="statusBadgeClass(campaign.status)">
                {{ statusLabel(campaign.status) }}
              </span>
            </dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Nombre del correo</dt>
            <dd class="text-sm font-medium text-gray-900 dark:text-white/90">{{ campaign.name }}</dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Asunto</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ campaign.subject || '—' }}</dd>
          </div>
          @if (campaign.preheader) {
            <div class="flex items-start gap-4 px-5 py-3">
              <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Preencabezado</dt>
              <dd class="text-sm text-gray-900 dark:text-white/90">{{ campaign.preheader }}</dd>
            </div>
          }
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Canal de envío</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ channelLabel(campaign.channelType) }}</dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Tipo de correo</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">Normal</dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Segmento utilizado</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">
              @if (lists.length === 0) {
                <span class="text-gray-400">—</span>
              } @else {
                <div class="flex flex-col gap-0.5">
                  @for (l of lists; track l.id) {
                    <span>{{ segmentName(l.idContactSegment) }}</span>
                  }
                </div>
              }
            </dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Contactos excluidos</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">
              @if (excludedContacts.length === 0 && excludedSegments.length === 0) {
                <span class="text-gray-400">Ninguno</span>
              } @else {
                {{ excludedContacts.length }} contacto{{ excludedContacts.length !== 1 ? 's' : '' }}
                @if (excludedSegments.length > 0) {
                  · {{ excludedSegments.length }} segmento{{ excludedSegments.length !== 1 ? 's' : '' }}
                }
              }
            </dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Fecha de creación</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ formatDate(campaign.createdAt) }}</dd>
          </div>
          <div class="flex items-start gap-4 px-5 py-3">
            <dt class="w-48 flex-shrink-0 text-sm text-gray-500 dark:text-gray-400 pt-0.5">Última actualización</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ formatDate(campaign.updatedAt) }}</dd>
          </div>
        </dl>
      </div>
    </div>

    <!-- Sidebar Detalle -->
    <div class="space-y-5 lg:col-span-2">
      <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
        <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60">
          <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            Programación y envío
          </h2>
        </div>
        <dl class="divide-y divide-gray-100 dark:divide-gray-800">
          <div class="flex items-center justify-between px-5 py-3">
            <dt class="text-sm text-gray-500 dark:text-gray-400">Programado para</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ formatDate(campaign.scheduledAt) }}</dd>
          </div>
          <div class="flex items-center justify-between px-5 py-3">
            <dt class="text-sm text-gray-500 dark:text-gray-400">Fecha de envío</dt>
            <dd class="text-sm text-gray-900 dark:text-white/90">{{ formatDate(campaign.sentAt) }}</dd>
          </div>
          <div class="flex items-center justify-between px-5 py-3">
            <dt class="text-sm text-gray-500 dark:text-gray-400">Progreso</dt>
            <dd class="text-sm font-semibold text-gray-900 dark:text-white/90">{{ progressPercent }}%</dd>
          </div>
        </dl>
        @if (campaign.totalRecipients > 0) {
          <div class="px-5 pb-4">
            <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
              <div class="h-full bg-teal-500 transition-all" [style.width.%]="progressPercent"></div>
            </div>
          </div>
        }
      </div>

      @if (campaign.lastError) {
        <div class="rounded-xl border border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/20 overflow-hidden">
          <div class="px-5 py-3.5 border-b border-red-100 dark:border-red-800 bg-red-50 dark:bg-red-900/30">
            <h2 class="text-xs font-semibold uppercase tracking-wider text-red-700 dark:text-red-300">Último error</h2>
          </div>
          <div class="p-5">
            <p class="text-sm text-red-700 dark:text-red-300 break-words">{{ campaign.lastError }}</p>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- ══════════════════════════════════════════
     TAB: MÉTRICAS (KPIs + tabla de destinatarios — Inc 36)
══════════════════════════════════════════ -->
@if (activeTab === 'metrics') {
  <div class="space-y-5">

    <!-- KPIs de envío -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60">
        <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Entrega</h2>
      </div>
      <div class="grid grid-cols-2 gap-px bg-gray-100 dark:bg-gray-800 sm:grid-cols-3 lg:grid-cols-5">
        @for (kpi of [
          { label: 'Destinatarios', value: (metrics?.totalRecipients ?? campaign.totalRecipients), color: 'text-gray-900 dark:text-white/90' },
          { label: 'Enviados',      value: (metrics?.sent ?? campaign.sentCount),                  color: 'text-blue-600 dark:text-blue-400' },
          { label: 'Entregados ✅', value: (metrics?.delivered ?? '—'),                            color: 'text-teal-600 dark:text-teal-400' },
          { label: 'Bounce ❌',     value: (metrics?.bounced ?? '—'),                              color: 'text-red-600 dark:text-red-400' },
          { label: 'Fallidos ⚠',   value: (metrics?.failed ?? campaign.failedCount),              color: 'text-red-600 dark:text-red-400' }
        ]; track kpi.label) {
          <div class="bg-white dark:bg-gray-900 p-5">
            <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ kpi.label }}</p>
            <p class="mt-2 text-3xl font-bold" [class]="kpi.color">{{ kpi.value }}</p>
          </div>
        }
      </div>
      @if (metrics?.skipped || metrics?.excludedByCampaign || metrics?.excludedBySuppression || metrics?.complained) {
        <div class="flex flex-wrap gap-4 px-5 py-3 border-t border-gray-100 dark:border-gray-800 text-xs text-gray-500 dark:text-gray-400">
          @if (metrics?.skipped) { <span>{{ metrics?.skipped }} saltados</span> }
          @if (metrics?.excludedByCampaign) { <span>{{ metrics?.excludedByCampaign }} excluidos por el correo</span> }
          @if (metrics?.excludedBySuppression) { <span>{{ metrics?.excludedBySuppression }} por suppression</span> }
          @if (metrics?.complained) { <span class="text-orange-600 dark:text-orange-400">{{ metrics?.complained }} marcados como spam</span> }
        </div>
      }
    </div>

    <!-- KPIs de engagement -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60">
        <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Engagement</h2>
      </div>
      <div class="grid grid-cols-2 gap-px bg-gray-100 dark:bg-gray-800 sm:grid-cols-4">
        <div class="bg-white dark:bg-gray-900 p-5">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Aperturas únicas 👁</p>
          <p class="mt-2 text-3xl font-bold text-green-600 dark:text-green-400">{{ metrics?.opens?.unique ?? '—' }}</p>
          <p class="mt-1 text-xs text-gray-400">{{ metrics?.opens?.total ?? 0 }} totales</p>
        </div>
        <div class="bg-white dark:bg-gray-900 p-5">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Open rate</p>
          <p class="mt-2 text-3xl font-bold text-green-600 dark:text-green-400">{{ formatRate(metrics?.opens?.openRate) }}</p>
          <p class="mt-1 text-xs text-gray-400">únicas / entregados</p>
        </div>
        <div class="bg-white dark:bg-gray-900 p-5">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Clicks únicos 🖱</p>
          <p class="mt-2 text-3xl font-bold text-violet-600 dark:text-violet-400">{{ metrics?.clicks?.unique ?? '—' }}</p>
          <p class="mt-1 text-xs text-gray-400">{{ metrics?.clicks?.total ?? 0 }} totales</p>
        </div>
        <div class="bg-white dark:bg-gray-900 p-5">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Click rate</p>
          <p class="mt-2 text-3xl font-bold text-violet-600 dark:text-violet-400">{{ formatRate(metrics?.clicks?.clickRate) }}</p>
          <p class="mt-1 text-xs text-gray-400">CTOR {{ formatRate(metrics?.clicks?.ctor) }}</p>
        </div>
      </div>
    </div>

    @if (metrics?.lastEventAt) {
      <p class="text-xs text-gray-400 dark:text-gray-500">
        Último evento registrado: {{ formatDate(metrics?.lastEventAt) }}
      </p>
    }

    <!-- Destinatarios (Inc 36: la ex-pestaña "Envío" vive aquí, debajo de los KPIs) -->
    <app-campaign-shipping [campaignId]="campaign.id" [metrics]="metrics"></app-campaign-shipping>
  </div>
}

<!-- ══════════════════════════════════════════
     TAB: AUDIENCIA
══════════════════════════════════════════ -->
@if (activeTab === 'audience') {
  <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">

    <!-- Segmentos incluidos -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60 flex items-center justify-between">
        <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Segmentos incluidos
        </h2>
        <span class="text-xs font-semibold text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-full px-2 py-0.5">
          {{ lists.length }}
        </span>
      </div>
      <div class="p-5">
        @if (lists.length === 0) {
          <p class="text-sm text-gray-400">Sin segmentos vinculados.</p>
        } @else {
          <ul class="space-y-2">
            @for (l of lists; track l.id) {
              <li class="rounded-lg bg-gray-50 dark:bg-gray-800 px-4 py-3">
                <p class="text-sm font-medium text-gray-900 dark:text-white/90">{{ segmentName(l.idContactSegment) }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  {{ l.sourceType === 'STATIC' ? 'Estática' : 'Dinámica' }} · {{ segmentTotal(l.idContactSegment) }} contactos
                </p>
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <!-- Contactos individuales -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60 flex items-center justify-between">
        <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Contactos individuales
        </h2>
        <span class="text-xs font-semibold text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-full px-2 py-0.5">
          {{ manualRecipients.length }}
        </span>
      </div>
      <div class="p-5">
        @if (manualRecipients.length === 0) {
          <p class="text-sm text-gray-400">Sin contactos adjuntos manualmente.</p>
        } @else {
          <ul class="space-y-2">
            @for (r of manualRecipients; track r.id) {
              <li class="flex items-center gap-3 rounded-lg bg-gray-50 dark:bg-gray-800 px-4 py-3">
                <svg class="h-4 w-4 flex-shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium text-gray-900 dark:text-white/90">{{ r.fullName }}</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">{{ r.email }}</p>
                </div>
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <!-- Contactos excluidos -->
    <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60 flex items-center justify-between">
        <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Contactos excluidos
        </h2>
        <span class="text-xs font-semibold rounded-full px-2 py-0.5"
              [class.bg-red-100]="excludedContacts.length > 0"
              [class.text-red-700]="excludedContacts.length > 0"
              [class.dark:bg-red-900/30]="excludedContacts.length > 0"
              [class.dark:text-red-400]="excludedContacts.length > 0"
              [class.bg-gray-200]="excludedContacts.length === 0"
              [class.text-gray-500]="excludedContacts.length === 0"
              [class.dark:bg-gray-700]="excludedContacts.length === 0"
              [class.dark:text-gray-400]="excludedContacts.length === 0">
          {{ excludedContacts.length }}
        </span>
      </div>
      <div class="p-5">
        @if (excludedContacts.length === 0) {
          <p class="text-sm text-gray-400">Ningún contacto excluido.</p>
        } @else {
          <ul class="space-y-2">
            @for (c of excludedContacts; track c.id) {
              <li class="flex items-center gap-3 rounded-lg bg-gray-50 dark:bg-gray-800 px-4 py-3">
                <svg class="h-4 w-4 flex-shrink-0 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium text-gray-900 dark:text-white/90">{{ c.fullName }}</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">{{ c.email }}</p>
                </div>
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <!-- "Segmentos excluidos" oculto (Inc 30): funcionalidad no en uso todavía. -->

  </div>
}

<!-- ══════════════════════════════════════════
     TAB: CONTENIDO
══════════════════════════════════════════ -->
@if (activeTab === 'content') {
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
    <div class="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60 flex items-center justify-between">
      <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
        Contenido del correo
      </h2>
      @if (campaign.bodyHtml) {
        <button (click)="togglePreview()"
                class="text-xs font-medium text-teal-600 hover:underline dark:text-teal-400">
          {{ showHtmlPreview ? 'Ver código' : 'Vista previa' }}
        </button>
      }
    </div>
    <div class="p-5 space-y-5">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <p class="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide mb-1">Asunto</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white/90">{{ campaign.subject || '—' }}</p>
        </div>
        @if (campaign.preheader) {
          <div>
            <p class="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide mb-1">Preencabezado</p>
            <p class="text-sm text-gray-900 dark:text-white/90">{{ campaign.preheader }}</p>
          </div>
        }
      </div>
      <div>
        <p class="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide mb-2">Cuerpo del correo</p>
        @if (showHtmlPreview && campaign.bodyHtml) {
          <iframe
            [srcdoc]="trustedBodyHtml"
            sandbox
            class="w-full min-h-[400px] rounded-lg border border-gray-200 dark:border-gray-700 bg-white"
            title="Vista previa del correo"
          ></iframe>
        } @else if (campaign.bodyHtml) {
          <pre class="whitespace-pre-wrap rounded-lg bg-gray-50 dark:bg-gray-800 p-4 font-mono text-xs text-gray-700 dark:text-gray-300 max-h-[500px] overflow-y-auto">{{ campaign.bodyHtml }}</pre>
        } @else if (campaign.bodyText) {
          <pre class="whitespace-pre-wrap rounded-lg bg-gray-50 dark:bg-gray-800 p-4 text-sm text-gray-700 dark:text-gray-300 max-h-[500px] overflow-y-auto">{{ campaign.bodyText }}</pre>
        } @else {
          <div class="rounded-lg border border-dashed border-gray-300 dark:border-gray-700 p-12 text-center">
            <p class="text-sm text-gray-400">Sin contenido registrado.</p>
            @if (campaign.status === 'DRAFT') {
              <button (click)="editRequested.emit()" class="mt-3 text-sm text-teal-600 hover:underline dark:text-teal-400">
                Ir al editor de contenido
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
